// extracted by mini-css-extract-plugin
export default {"list":"Timeline_list__6VazC","container":"Timeline_container__n1BtG"};